// extracted by mini-css-extract-plugin
export default {"desktopSidebar":"root_sidebar-island-module__desktopSidebar___kQ7LL","mobileSidebarHeader":"root_sidebar-island-module__mobileSidebarHeader___Y_EDh"};